<template>
  <img src="../../assets/images/icons/arrow-down-select.svg" alt="v">
</template>

<script>
export default {
  name: "ArrowDownSelect"
}
</script>
